import { Component, ChangeDetectionStrategy, computed, inject, signal } from '@angular/core';
import { MaterialModule } from "../../_shared";
import { RouterModule } from '@angular/router';
import { ThemeMode, ThemeService } from "../../_services";

const THEME_ICONS: Record<ThemeMode, string> = {
  light: 'light_mode',
  dark: 'dark_mode',
  system: 'brightness_auto',
};

@Component({
  selector: 'app-header',
  imports: [MaterialModule, RouterModule],
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.scss',
})
export class Header {
  private readonly themeService = inject(ThemeService);
  private readonly currentTheme = signal<ThemeMode>(this.themeService.theme);
  protected readonly themeIcon = computed(() => THEME_ICONS[this.currentTheme()]);

  setTheme(theme: ThemeMode): void {
    this.themeService.applyTheme(theme);
    this.currentTheme.set(theme);
  }
}
